import React, { useEffect, useState } from "react";
import { useB2BContext } from "../../context/ContextB2B";
import { authSVC } from "../../services";
import {
  Space,
  Table,
  Input,
  Button,
  message,
  Form,
  Select,
  Collapse,
} from "antd";

interface ModuleItem {
  _id: string;
  moduleName: string;
  label: string;
  code: string;
  allowAccess: boolean;
  is_hidden?: boolean;
}

interface ModuleGroup {
  moduleName: string;
  moduleItem: ModuleItem[];
}

interface Props {
  preSelectPackages?: string[];
  modules: ModuleGroup[];
}

const RequestAddons: React.FC<Props> = ({
  preSelectPackages = [],
  modules,
}) => {
  const { setSelectedModulesList, getUserByID } = useB2BContext();
  const [selectedPackages, setSelectedPackages] =
    useState<string[]>(preSelectPackages);

  useEffect(() => {
    console.log(preSelectPackages, "preSelectPackages");
    console.log(modules, "modules");
  }, [preSelectPackages, modules]);

  const handleCheckboxChange = (id: string) => {
    console.log(id);
    setSelectedPackages((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((pkgId) => pkgId !== id)
        : [...prevSelected, id]
    );
  };

  useEffect(() => {
    setSelectedPackages(preSelectPackages);
  }, [preSelectPackages]);

  // useEffect(() => {
  //   if (selectedPackages) {
  //     setSelectedModulesList(selectedPackages);
  //   }
  // }, [selectedPackages, setSelectedModulesList]);

  const AddOnSubmit = () => {
    console.log(selectedPackages, "Test");
    let pkgDetails: any = {};
    pkgDetails = {
      company_id: getUserByID.company_id?._id,
      addons: selectedPackages,
      user_id: getUserByID._id,
    };
    authSVC
      .RequestAddons(pkgDetails)
      .then((res: any) => {
        console.log(res.data, "RequestOndemandService");
        // setReferenceId(res?.data?.data?.reference_id);
        // // setPackageData(res.data.package);
        // setIsModalOpenReference(true);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  return (
    <div className="checkbox_list_wrapper">
      {modules.map((moduleGroup, index) => (
        <div key={index}>
          <h3>{moduleGroup.moduleName}</h3>
          <ul>
            {moduleGroup.moduleItem.map((item) => (
              <li key={item._id}>
                <label>{item.label}</label>
                <input
                  type="checkbox"
                  checked={selectedPackages.includes(item._id)}
                  onChange={() => handleCheckboxChange(item._id)}
                  disabled={!item.allowAccess}
                />
              </li>
            ))}
          </ul>
        </div>
      ))}
      <button
        className="cn_btn"
        style={{ margin: "36px auto" }}
        onClick={AddOnSubmit}
      >
        Request for add-on changes
      </button>
    </div>
  );
};

export default RequestAddons;
